var always = require('./always');


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
module.exports = always(true);



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/T.js
// module id = ./node_modules/ramda/src/T.js
// module chunks = 53 54 55